import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractTranslatedApiErrorMessage } from '../../shared/utils/translate-api-error.util';
import { DeliveryPointDetails } from '../types/delivery-point-details.type';
import { CreateDeliveryPointRequestDTO } from '../types/dtos/create-delivery-point.dto';
import { ADMIN_DELIVERY_POINTS_API_PATHS } from '../constants/delivery-points-api-paths.constants';

type UseCreateDeliveryPointResult = {
  isSubmitting: boolean;
  createDeliveryPoint: (data: CreateDeliveryPointRequestDTO) => Promise<DeliveryPointDetails | null>;
};

export function useCreateDeliveryPoint(): UseCreateDeliveryPointResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const createDeliveryPoint = async (data: CreateDeliveryPointRequestDTO): Promise<DeliveryPointDetails | null> => {
    setIsSubmitting(true);

    try {
      const createdDeliveryPoint = await HttpClient.post<DeliveryPointDetails, CreateDeliveryPointRequestDTO>(
        ADMIN_DELIVERY_POINTS_API_PATHS.CREATE_DELIVERY_POINT,
        data
      );

      enqueueSnackbar('Point de livraison créé', { variant: 'success' });
      return createdDeliveryPoint;
    } catch (error) {
      enqueueSnackbar(
        extractTranslatedApiErrorMessage(error, 'Une erreur est survenue lors de la création du point de livraison'),
        { variant: 'error' }
      );
      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { isSubmitting, createDeliveryPoint };
}
